import {
  OnSiteTimeReportFormDefaultValues,
  OnSiteTimeReportFormProps,
  OnSiteTimeReportFormRawValues,
  OnSiteTimeReportFormType
} from "./OnSiteTimeReportForm";
import {useForm} from "@mantine/form";
import {getObjectId} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: OnSiteTimeReportFormDefaultValues | undefined): OnSiteTimeReportFormRawValues => {
  return {
    date: defaultValues?.date,
    operator: getObjectId(defaultValues?.operator),
    site: getObjectId(defaultValues?.site),
    siteCompany: getObjectId(defaultValues?.siteCompany),
  }
}

export type UseOnSiteTimeReportFormProps = Pick<OnSiteTimeReportFormProps, 'defaultValues'> & {}

export function useOnSiteTimeReportForm(props: UseOnSiteTimeReportFormProps): OnSiteTimeReportFormType {
  const {
    defaultValues
  } = props

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
  })

  return form
}
